import { Article } from '../../rent/model/article';
import { CodingConfig } from './coding';

export class InvoiceRowFormDefaultsModel {
  constructor(context) {
    this.codingConfig = context.codingConfig;
    this.articleSelection = context.articleSelection.map(a => new Article(a));
    this.companyCultureCode = context.companyCultureCode;
    this.currencyCode = context.currencyCode;
  }
  codingConfig: CodingConfig;
  articleSelection: Article[];
  companyCultureCode: string;
  currencyCode: string;
}
